/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import styles from './PageName.css';

/**
 * PageName
 * @param {string} pageName - the name of the selected page
 * @returns {Component} a page name in a div
 */
export default class PageName extends Component {
  static propTypes = {
    isPageSelected: propTypes.bool.isRequired,
    pageName: propTypes.string.isRequired,
    removeActivePage: propTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.removePage = this.removePage.bind(this);
  }

  /**
   * Remove active page
   */
  removePage() {
    this.props.removeActivePage();
  }

  /**
   * render active page name
   * @returns {Node} page name and deselect option
   */
  renderPageName() {
    const { pageName } = this.props;

    return (
      <div className="px-4 pb-4" data-test-id="page-name-active">
        <div
          className={classnames(
            'd-flex flex-row justify-content-between align-items-center',
            styles.pageName
          )}
        >
          <span title={pageName} className={styles.pageNameText}>
            {pageName}
          </span>
          <span
            title="Close"
            className={styles.removeActivePage}
            onClick={this.removePage}
            data-test-id="page-name-remove"
          >
            &times;
          </span>
        </div>
      </div>
    );
  }

  render() {
    const { isPageSelected } = this.props;

    if (isPageSelected) {
      return <div className={styles.wrapper}>{this.renderPageName()}</div>;
    }
    return null;
  }
}
